enum NotificationType {
    Invoice = 'INVOICE',
    InvoiceExpiration = 'INVOICE_EXPIRATION',
    Budget = 'BUDGET',
    BudgetExpiration = 'BUDGET_EXPIRATION',
    SellerRegister = 'SELLER_REGISTER',
}

export default NotificationType;
